<div class="clamp-wrap" [class.expanded]="expanded">
  <div
    #content
    class="clamp"
    [class.clamped]="!expanded"
    [style.--lines]="lines"
  >
    <ng-content></ng-content>
  </div>
  <a
    *ngIf="showMore && !expanded"
    href="#"
    class="a more-link"
    (click)="onMoreClick(); $event.preventDefault()"
  >More</a>
</div>
